<template>
	<div class="advanced-settings-container">
		<div v-if="hasEditPermissions" @click="isOpen = !isOpen" class="title-container display-flex flex-row flex-align-center">
			<div>Advanced</div>
			<v-icon class="chevron-icon ml-2">{{ `mdi-chevron-${isOpen ? 'up' : 'down'}` }}</v-icon>
		</div>

		<div v-if="isOpen" class="menu-container mt-5 display-flex flex-column">
			i-async
			<div class="display-flex flex-column mt-2">
				<v-switch inset dense color="white" v-model="asyncRunAfterAllPrevious" class="swtch drk sml acync-icon">
					<template v-slot:label>
						<div class="switch-text">Run after previous steps</div>
						<SIcon name="iasync-down" class="ml-2" />
					</template>
				</v-switch>
				<v-switch inset dense color="white" v-model="asyncRunBeforeAllFollowing" class="swtch drk sml acync-icon">
					<template v-slot:label>
						<div class="switch-text">Run before next steps</div>
						<SIcon name="iasync-up" class="ml-2" />
					</template>
				</v-switch>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import { canEditWorkflow } from '@/store/modules/workflows/getters';
import { partialUpdateEditNode } from '@/utils/workflow-node-service';
export default {
	name: 'AdvancedSettings',
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters([canEditWorkflow.fullPath]),
		hasEditPermissions() {
			return this[canEditWorkflow.fullPath](this.editNode?.workflow);
		},
		asyncRunAfterAllPrevious: {
			get() {
				return this.editNode.async_run_after_all_previous_flag;
			},
			async set(value) {
				await partialUpdateEditNode({ async_run_after_all_previous_flag: value });
			},
		},
		asyncRunBeforeAllFollowing: {
			get() {
				return this.editNode.async_before_all_following_flag;
			},
			async set(value) {
				await partialUpdateEditNode({ async_before_all_following_flag: value });
			},
		},
	},
	data: () => ({
		isOpen: false,
	}),
};
</script>

<style scoped lang="scss">
.advanced-settings-container {
	.title-container {
		font-size: 14px;
		cursor: pointer;
		background: transparent;
		color: var(--bold-title);

		.chevron-icon {
			width: 7px;
			height: 3px;
			margin-top: 2px;
			color: var(--bold-title);
		}
	}

	.menu-container {
		font-size: 14px;
		font-weight: bold;
		color: var(--bold-title);
	}
	.acync-icon {
		margin-left: -12% !important;
	}
	.switch-text {
		color: var(--primary-font-color);
	}
}
</style>
